import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export const removeStackFromDesign = (set, get, stackId) => {
  const state = get();
  if (!state || !state.designs || !state.designs[state.selectedDesignId]) return;

  const design = state.designs[state.selectedDesignId];
  const stacks = Array.isArray(design.Stacks) ? [...design.Stacks] : [];

  const idx = stacks.findIndex((stack) => String(stack.StackId) === String(stackId));
  if (idx === -1) return; // Stack not found, nothing to remove

  stacks.splice(idx, 1);

  set({
    designs: {
      ...state.designs,
      [state.selectedDesignId]: {
        ...design,
        Stacks: stacks,
      },
    },
  }, false, { type: 'REMOVE_STACK_FROM_DESIGN', payload: { stackId } });

  logNewRelicCustom(NEW_RELIC_EVENTS.STACK_REMOVED, { stackId });
};